module.exports = __webpack_public_path__ + "img/header-page-background.584cc320.svg";